import { Switch as SwitchUI } from "artisn-ui-react";
import styled from "styled-components";

import { SwitchStyledProps as Props } from "./Switch.types";

const SwitchStyled = styled(SwitchUI)<Props>`
  && .Switch {
    &__slider {
      background-color: var(--palette-black-s2-l17);

      &:before {
        background-color: var(--palette-white);
      }
    }

    &__wrapper {
      border: 1px solid var(--palette-primary);
    }
  }
`;

export default SwitchStyled;
